'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HR;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _theme = require('HubStyleTokens/theme');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _Styles = require('../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledHR = _styledComponents2.default.hr.withConfig({
  displayName: 'HR__StyledHR'
})(['background-color:', ';border:0;height:1px;min-height:1px;width:100%;', ';'], _theme.HR_BORDER_COLOR, function (_ref) {
  var distance = _ref.distance;
  return (0, _Styles.setDistance)(distance);
});

function HR(props) {
  return _react2.default.createElement(StyledHR, props);
}

HR.propTypes = {
  distance: _propTypes2.default.oneOfType([_tshirtSize.allSizes, _propTypes2.default.oneOf(['flush'])])
};

HR.defaultProps = {
  distance: 'md'
};

HR.displayName = 'HR';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/elements/HR.js
// module id = 585
// module chunks = 177